import { Header, NotFoundMain } from "components"

const NotFound = () => {
  return (
    <NotFoundMain/>
  )
}

export default NotFound
